import React from "react";
import AppRouter from "@app/routes";

const App = () => <AppRouter />;

export default App;
